import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldCheck, FileText, Lock, BadgeCheck } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { LegalBlocks } from "./legalContent";

const ICONS = { compliance: BadgeCheck, security: ShieldCheck, terms: FileText, privacy: Lock };
const API = process.env.REACT_APP_BACKEND_URL;

/** Κείμενα αρχικής σελίδας (διαχειρίσιμα από Admin → Εργαλεία): μόνο όσα είναι ενεργά (visible). */
export const LegalAccordion = () => {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/legal-docs`).then((r) => setDocs(r.data?.docs || [])).catch(() => setDocs([]));
  }, []);

  if (!docs.length) return null;
  return (
    <Accordion type="single" collapsible className="w-full border-t border-slate-200" data-testid="legal-accordion">
      {docs.map((d) => {
        const Icon = ICONS[d.key] || FileText;
        return (
          <AccordionItem key={d.key} value={d.key} className="border-slate-200">
            <AccordionTrigger className="py-3 text-sm sm:text-base font-semibold text-slate-800 hover:no-underline hover:text-slate-950 gap-3 text-left" data-testid={`legal-trigger-${d.key}`}>
              <span className="flex items-center gap-3">
                <span className="w-8 h-8 rounded-lg bg-slate-100 border border-slate-200 flex items-center justify-center shrink-0">
                  <Icon className="w-4 h-4 text-slate-700" />
                </span>
                {d.title}
              </span>
            </AccordionTrigger>
            <AccordionContent data-testid={`legal-content-${d.key}`}>
              <div className="max-h-72 overflow-y-auto pr-3 text-sm leading-relaxed text-slate-600 rounded-xl border border-slate-200 bg-slate-50/60 px-4 py-3">
                {d.updated && <p className="text-xs text-slate-400 italic mb-2" data-testid={`legal-updated-${d.key}`}>{d.updated}</p>}
                <LegalBlocks content={d.content} />
              </div>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
};
